const featureExchangeApi = ({ exchange, exchangeAssets, exchangeLimits, exchangeQuotes, exchangeProviders, }) => ({
    exchange: {
        getBestQuote: exchangeQuotes.getBestQuote,
        getLimits: exchangeLimits.getLimits,
        getPrefilledAmounts: exchangeLimits.getPrefilledAmounts,
        ackExchange: exchange.ackExchange,
        cancelExchange: exchange.cancelExchange,
        exchange: exchange.exchange,
        prepareExchange: exchange.prepareExchange,
        executeExchange: exchange.executeExchange,
        getSupportedFromAssetIds: exchangeAssets.getSupportedFromAssetIds,
        getSupportedToAssetIds: exchangeAssets.getSupportedToAssetIds,
        prefetchPairs: exchangeProviders.buildExchangeableAssets,
        searchAssets: exchangeAssets.searchAssets,
        isPairSupported: exchangeAssets.isPairSupported,
        isAssetExchangeable: exchangeAssets.isAssetExchangeable,
        isAssetExchangeableTo: exchangeAssets.isAssetExchangeableTo,
        isAssetExchangeableFrom: exchangeAssets.isAssetExchangeableFrom,
    },
});
const exchangeDefinition = {
    id: 'exchangeApi',
    type: 'api',
    factory: featureExchangeApi,
    dependencies: [
        'exchange',
        'exchangeAssets',
        'exchangeLimits',
        'exchangeQuotes',
        'exchangeProviders',
    ],
};
export default exchangeDefinition;
